import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {useHistory} from 'react-router-dom';
import DossierStateCell from '../../dossier/DossierStateCell';
import {PROJECT_STATUS} from '../../../utils/constant';

function ListItemView({intervention, showDossierState, dossierState}) {
  const {project} = intervention;
  const history = useHistory();

  function handleLinkIntervention(event) {
    event.preventDefault();
    history.push(`/projects?query=${project.name}`);
  }

  return (
    <tr onClick={handleLinkIntervention}>
      <td>{project.name}</td>
      <td className="information">
        {project.projectStatus === PROJECT_STATUS.CLOSED && <Translate value="project.closedProject"/>}
      </td>
      <td>{project.ownerOrganisation.fullName}</td>
      <td>{project.address.postCode}</td>
      <td>{project.address.city}</td>
      <td>
        <Translate value={`country.${project.ownerOrganisation.country}`}/>
      </td>
      {showDossierState && <DossierStateCell state={dossierState}/>}
    </tr>
  );
}

ListItemView.propTypes = {
  intervention: PropTypes.object.isRequired,
  showDossierState: PropTypes.bool,
  dossierState: PropTypes.string
};

export default ListItemView;
